import type { RouteObject } from "react-router";
import { RequireCapability } from "@/features/account/RequireCapability";
import { NotFoundPage } from "@/features/errors/NotFoundPage";
import { SECTION_CAPABILITY } from "./adminNav";
import { AuthorizationsPage } from "./authorizations/AuthorizationsPage";
import { CompanyProfilePage } from "./company/CompanyProfilePage";
import { ContentSafetyPage } from "./contentSafety/ContentSafetyPage";
import { FeedbackDetailPage } from "./feedback/FeedbackDetailPage";
import { FeedbackPage } from "./feedback/FeedbackPage";
import { GovernancePage } from "./governance/GovernancePage";
import { IntegrationDetailPage } from "./integrations/IntegrationDetailPage";
import { IntegrationsPage } from "./integrations/IntegrationsPage";
import { LicensePage } from "./license/LicensePage";
import { ModelDefaultsPage } from "./models/ModelDefaultsPage";
import { ModelDetailPage } from "./models/ModelDetailPage";
import { ModelsPage } from "./models/ModelsPage";
import { NewModelPage } from "./models/NewModelPage";
import { OAuthClientsPage } from "./oauthClients/OAuthClientsPage";
import { BudgetsPage } from "./usage/BudgetsPage";
import { PlatformCostsPage } from "./usage/PlatformCostsPage";
import { UsageByUserPage } from "./usage/UsageByUserPage";
import { UsageOverviewPage } from "./usage/UsageOverviewPage";
import { NewUserPage } from "./users/NewUserPage";
import { UsersPage } from "./users/UsersPage";

/** Children of /admin (AdminLayout). Keep in sync with adminNav.tsx. */
export const adminRoutes: RouteObject[] = [
  { path: "users", element: <UsersPage /> },
  { path: "users/new", element: <NewUserPage /> },
  { path: "company", element: <CompanyProfilePage /> },
  { path: "feedback", element: <FeedbackPage /> },
  { path: "feedback/:feedbackUuid", element: <FeedbackDetailPage /> },
  { path: "models", element: <ModelsPage /> },
  { path: "models/new", element: <NewModelPage /> },
  { path: "models/:modelId", element: <ModelDetailPage /> },
  { path: "model-defaults", element: <ModelDefaultsPage /> },
  { path: "integrations", element: <IntegrationsPage /> },
  { path: "integrations/:uuid", element: <IntegrationDetailPage /> },
  {
    path: "governance",
    element: (
      <RequireCapability capability={SECTION_CAPABILITY.governance}>
        <GovernancePage />
      </RequireCapability>
    ),
  },
  { path: "content-safety", element: <ContentSafetyPage /> },
  { path: "usage", element: <UsageOverviewPage /> },
  { path: "usage/users", element: <UsageByUserPage /> },
  { path: "usage/budgets", element: <BudgetsPage /> },
  {
    path: "usage/costs",
    element: (
      <RequireCapability capability={SECTION_CAPABILITY.platformCosts}>
        <PlatformCostsPage />
      </RequireCapability>
    ),
  },
  { path: "license", element: <LicensePage /> },
  {
    path: "oauth-clients",
    element: (
      <RequireCapability capability={SECTION_CAPABILITY.oauthClients}>
        <OAuthClientsPage />
      </RequireCapability>
    ),
  },
  {
    path: "authorizations",
    element: (
      <RequireCapability capability={SECTION_CAPABILITY.authorizations}>
        <AuthorizationsPage />
      </RequireCapability>
    ),
  },
  { path: "*", element: <NotFoundPage /> },
];
